import { CallActionType } from "../../../call-center";
import { VoiceMessageBuilder } from "../lines/voice-message.builder";
var NonAvailableAgentsSettingsBuilder = /** @class */ (function () {
    function NonAvailableAgentsSettingsBuilder() {
        this.nonAvailableAgentsSettings = {
            nonAvailableAgentsMessage: new VoiceMessageBuilder().build(),
            nonAvailableAgentsAction: {
                type: CallActionType.HANGUP,
            },
        };
    }
    NonAvailableAgentsSettingsBuilder.prototype.withVoiceMessage = function (nonAvailableAgentsMessage) {
        this.nonAvailableAgentsSettings.nonAvailableAgentsMessage = nonAvailableAgentsMessage;
        return this;
    };
    NonAvailableAgentsSettingsBuilder.prototype.withCallAction = function (nonAvailableAgentsAction) {
        this.nonAvailableAgentsSettings.nonAvailableAgentsAction = nonAvailableAgentsAction;
        return this;
    };
    NonAvailableAgentsSettingsBuilder.prototype.build = function () {
        return this.nonAvailableAgentsSettings;
    };
    return NonAvailableAgentsSettingsBuilder;
}());
export { NonAvailableAgentsSettingsBuilder };
//# sourceMappingURL=non-available-agents-settings.builder.js.map